// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__10zRm","title":"Header_title__euZaY","side":"Header_side__31lw5"};